import React from 'react';

const QuickDate = ({ pregunta, answer, onAnswer }) => {
  const { opciones = [] } = pregunta;
  const opcionId  = answer?.opcionId || null;
  const customDate = answer?.date || '';

  const select = (opcion) => {
    if (opcion.esDatePicker) {
      onAnswer({ opcionId: 'custom', date: customDate });
    } else {
      onAnswer({ opcionId: opcion.id });
    }
  };

  return (
    <div className="space-y-2.5">
      <div className="flex flex-wrap gap-2">
        {opciones.map(opcion => {
          const selected = opcion.esDatePicker
            ? opcionId === 'custom'
            : opcionId === opcion.id;
          return (
            <button
              key={opcion.id}
              type="button"
              onClick={() => select(opcion)}
              className={`flex items-center gap-1.5 px-3 py-2 rounded-xl border-2 text-sm font-semibold transition-all ${
                selected
                  ? 'border-red-500 bg-red-50 text-red-700 shadow-sm'
                  : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              {opcion.label}
              {selected && !opcion.esDatePicker && (
                <span className="text-red-500 text-xs font-bold">✓</span>
              )}
            </button>
          );
        })}
      </div>

      {opcionId === 'custom' && (
        <input
          type="date"
          autoFocus
          className="px-3 py-2 border-2 border-red-300 rounded-xl text-sm outline-none focus:border-red-500 bg-red-50"
          value={customDate}
          max={new Date().toISOString().split('T')[0]}
          onChange={e => onAnswer({ opcionId: 'custom', date: e.target.value })}
          onKeyDown={e => e.stopPropagation()}
        />
      )}
    </div>
  );
};

export default QuickDate;
